import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import PerfectScrollbar from "react-perfect-scrollbar";
import root from "react-shadow";
import { Button, ButtonGroup } from "react-bootstrap";
import {
  Call,
  Cancel,
  ConfirmationNumber,
  Delete,
  Email,
} from "@mui/icons-material";
import DialogLayout from "../../../../partials/content/DialogLayout";
import LeadDetail from "../leads/leadDetail/leadDetail";
import { DialogActions } from "@material-ui/core";
import CustomerDetail from "../../sales/customers/customerDetail/customerDetail";
import AssignEmailForm from "./assignEmailForm";
import TicketForm from "../ticket/ticketForm";
import {
  blockEmail,
  getInquiryDetail,
  moveInquiryToJunk,
} from "../../../../services/crm/inquiryService";
import LeadForm from "../leads/leadForm";
import Swal from "sweetalert2";
function InquiryDetail({ inquiryID = 0, onReloadInquires, onCloseDialog }) {
  const [openTicketForm, setOpenTicketForm] = useState(false);
  const [openAssignEmailForm, setOpenAssignEmailForm] = useState(false);
  const [openLeadForm, setOpenLeadForm] = useState(false);
  const [openLeadDetail, setOpenLeadDetail] = useState(false);
  const [openCustomerDetail, setOpenCustomerDetail] = useState(false);
  const [customerID, setCustomerID] = useState(0);
  const [contactID, setContactID] = useState(0);
  const [lead, setLead] = useState({});
  const [auth, setAuth] = useState({});
  const [leadAuth, setLeadAuth] = useState({});
  const [inquiry, setInquiry] = useState({
    ID: 0,
    customer: {
      ID: 0,
    },
    customerContacts: { ID: 0 },
    lead: { ID: 0 },
    emailFrom: "",
    subject: "",
    body: "",
  });

  useEffect(() => {
    getInquiryDetailData(inquiryID);
  }, [inquiryID]);
  return (
    <React.Fragment>
      <div
        style={{
          minHeight: "100px",
          border: "1px solid #ccc",
          padding: "10px",
          borderBottom: 0,
        }}
      >
        <div className="row">
          <div
            className="col-sm-6 col-md-6 col-lg-6"
            style={{ paddingBottom: "10px" }}
          >
            <button
              className={`btn btn-${
                inquiry.customer.ID > 0 || inquiry.customerContacts.ID > 0
                  ? "success"
                  : inquiry.lead.ID > 0
                  ? "info"
                  : "danger"
              } btn-md btn-pill btn-bold`}
              onClick={() => {
                if (
                  inquiry.customer.ID > 0 ||
                  inquiry.customerContacts.ID > 0
                ) {
                  setOpenCustomerDetail(true);
                } else if (inquiry.lead.ID > 0) {
                  setOpenLeadDetail(true);
                }
              }}
            >
              <i className="fas fa-flag"></i>
              {inquiry.customer.ID > 0 || inquiry.customerContacts.ID > 0
                ? `Customer - ${inquiry.customer.customerName}`
                : inquiry.lead.ID > 0
                ? `Lead - ${inquiry.lead.leadName} - ${inquiry.lead.contactName}`
                : "Not Registered"}
            </button>
            <br />
            <br />
            <p style={{ margin: 0 }}>
              Subject : <strong>{inquiry.subject}</strong>
            </p>
            <p style={{ margin: 0 }}>
              Email : <strong>{inquiry.emailFrom}</strong>
            </p>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <ButtonGroup size="sm" className="float-right">
              {inquiry.lead.ID === 0 && customerID === 0 ? (
                <React.Fragment>
                  {leadAuth.create ? (
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setOpenLeadForm(true);
                      }}
                    >
                      <Call /> New Lead
                    </Button>
                  ) : null}
                  <Button
                    onClick={() => {
                      setOpenAssignEmailForm(true);
                    }}
                    variant="secondary"
                  >
                    <Email /> Assign Email
                  </Button>
                </React.Fragment>
              ) : (
                <Button
                  onClick={() => {
                    setOpenTicketForm(true);
                  }}
                  variant="secondary"
                >
                  <ConfirmationNumber /> New Ticket
                </Button>
              )}
              <Button
                variant="secondary"
                onClick={() => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                      cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  })
                    .fire({
                      title: `Are you sure want to mark this email ${inquiry.emailFrom} as spam ?`,
                      text:
                        "Please note that system will ignore messages from this email address",
                      icon: "question",
                      showCloseButton: true,
                      showCancelButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, mark it`,
                      cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                      reverseButtons: true,
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        blockEmail(inquiry.emailFrom).then((response) => {
                          Swal.mixin({
                            customClass: {
                              confirmButton:
                                "btn btn-success btn-md btn-pill btn-bold",
                            },
                            buttonsStyling: false,
                          }).fire({
                            title: "Saved",
                            html: response.data.message,
                            icon: "success",
                            showCloseButton: true,
                            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                          });
                          onReloadInquires();
                        });
                      } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Cancelled",
                          text: "No change has been made",
                          icon: "info",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                      }
                    });
                }}
              >
                <Cancel /> Mark as Spam
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                      cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  })
                    .fire({
                      title: "Are you sure want to move this message to junk ?",
                      text:
                        "Please note that you are responsible for this action",
                      icon: "question",
                      showCloseButton: true,
                      showCancelButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, move it`,
                      cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                      reverseButtons: true,
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        moveInquiryToJunk(inquiry).then((response) => {
                          Swal.mixin({
                            customClass: {
                              confirmButton:
                                "btn btn-success btn-md btn-pill btn-bold",
                            },
                            buttonsStyling: false,
                          }).fire({
                            title: "Saved",
                            html: response.data.message,
                            icon: "success",
                            showCloseButton: true,
                            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                          });
                          onReloadInquires();
                        });
                      } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Cancelled",
                          text: "No change has been made",
                          icon: "info",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                      }
                    });
                }}
              >
                <Delete /> Move to Junk
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div
            style={{
              height: "600px",
              border: "1px solid #ccc",
              padding: "10px",
            }}
          >
            <PerfectScrollbar>
              <root.div>{parse(inquiry.body)}</root.div>
            </PerfectScrollbar>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openLeadForm}
        title="Lead Form"
        onCloseDialog={handleCloseLeadForm}
      >
        <div
          style={{
            height: "600px",
            border: "1px solid #ccc",
            padding: "10px",
          }}
        >
          <PerfectScrollbar>
            <root.div>{parse(inquiry.body)}</root.div>
          </PerfectScrollbar>
        </div>
        <LeadForm
          emailFrom={inquiry.emailFrom}
          onCloseDialog={handleCloseLeadForm}
          onConfirmSave={handleReloadInquiry}
        />
      </DialogLayout>
      <DialogLayout
        open={openLeadDetail}
        title="Lead Detail"
        //color="#f2f3f8"
        maxWIdth="xl"
        onCloseDialog={handleCloseLeadDetail}
      >
        <LeadDetail leadID={lead.ID} inquiryID={inquiry.ID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseLeadDetail}
          >
            <i className="fas fa-window-close"></i>
            Cancel
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openCustomerDetail}
        title="Customer Detail"
        //color="#f2f3f8"
        maxWIdth="xl"
        onCloseDialog={handleCloseCustomerDetail}
      >
        <CustomerDetail customerIDimp={customerID} />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseCustomerDetail}
          >
            <i className="fas fa-window-close"></i>
            Cancel
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openAssignEmailForm}
        title="Assign Email to Customer"
        onCloseDialog={handleCloseAssignEmailForm}
      >
        <AssignEmailForm
          emailFrom={inquiry.emailFrom}
          onReloadInquiry={handleReloadInquiry}
          onCloseDialog={handleCloseAssignEmailForm}
        />
      </DialogLayout>
      <DialogLayout
        open={openTicketForm}
        title="Ticket Form"
        onCloseDialog={handleCloseTicketForm}
      >
        <TicketForm
          leadID={lead.ID}
          customerID={customerID}
          contactID={contactID}
          inquiryID={inquiry.ID}
          subject={inquiry.subject}
          onCloseDialog={handleCloseTicketForm}
          onSaveConfirm={onReloadInquires}
        />
      </DialogLayout>
    </React.Fragment>
  );

  function handleCloseTicketForm() {
    setOpenTicketForm(false);
  }

  function handleCloseAssignEmailForm() {
    setOpenAssignEmailForm(false);
  }

  function handleCloseLeadForm() {
    setOpenLeadForm(false);
  }

  function handleCloseLeadDetail() {
    setOpenLeadDetail(false);
  }

  function handleCloseCustomerDetail() {
    setOpenCustomerDetail(false);
  }

  function handleReloadInquiry() {
    getInquiryDetailData(inquiryID);
    setOpenLeadForm(false);
    setOpenAssignEmailForm(false);
    setOpenTicketForm(false);
    setInquiry(inquiry);
  }

  async function getInquiryDetailData(inquiryID) {
    const response = await getInquiryDetail(inquiryID);
    const { data, auth, leadAuth } = response.data;
    setInquiry(data.inquiry);
    setLead(data.inquiry.lead);
    setAuth(auth);
    setLeadAuth(leadAuth);
    if (data.inquiry.customerContacts.ID > 0) {
      setCustomerID(data.inquiry.customerContacts.customerID);
      setContactID(data.inquiry.customerContacts.ID);
    } else if (data.inquiry.customer.ID > 0) {
      setCustomerID(data.inquiry.customer.customerID);
      setContactID(0);
    } else {
      setCustomerID(0);
      setContactID(0);
    }
  }
}

export default InquiryDetail;
